import filterListItems from 'client/helpers/filterListItems';

export default function getSearchFilterSettings({ searchFilterId, market }) {
  const searchFilterSettings = filterListItems[searchFilterId];
  const marketSearchFilterSettings = (market.settings.searchFilters || {})[searchFilterId] || {};

  if (!searchFilterSettings) {
    throw new Error(`Not found settings for search filter "${searchFilterId}"`);
  }

  const newSearchFilterSettings = {
    ...searchFilterSettings,
  };

  if (marketSearchFilterSettings.disabledOptions && newSearchFilterSettings.optionList) {
    newSearchFilterSettings.optionList = newSearchFilterSettings.optionList.filter(
      (optionList) => !marketSearchFilterSettings.disabledOptions.includes(optionList.value),
    );
  }

  return newSearchFilterSettings;
}
